import { IAccountCluster } from '@/contracts/AccountClusterContract';
import { DataSource } from './abstract-data-source';
import { AbstractDataSourceType } from './abstract-data-source-type';

export interface AccountClusterDataType extends AbstractDataSourceType, IAccountCluster {

}

export class AccountClustersDataSource extends DataSource {
  public data: AccountClusterDataType[];

  constructor(accountClusters: IAccountCluster[]) {
    super(accountClusters);
  }
}
